import quoteDetailTable from './quoteDetailTable';

export default quoteDetailTable;



// WEBPACK FOOTER //
// ./src/components/grids/QuoteDetailTable/index.jsx